var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-up"},[_c('img',{staticClass:"icon-camera",attrs:{"src":require("./assets/upload_img_icon.png"),"alt":""}}),_c('input',_vm._g({attrs:{"id":_vm.id,"type":"file","name":"file","accept":"image/*"}},_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }